import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CartService } from '../../services/cart.service';

const BASE_URL = environment.apiUrl;

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})

export class ThankYouComponent {
  sessionKey: string | null = null;
  isSuccess: boolean = false;
  isLoaded: boolean = false;
  title: string = '';
  message: string = '';
  messageItem: String = 'In case of any queries, concerns, or issues, please feel free to reach out to us. Our support team will be happy to assist you and provide the necessary guidance at the earliest.,<br> E-Mail ID: <b>sample@gmail.com</b><br> Phone No.: <b>8122782822</b>';

  constructor(private route: ActivatedRoute, private http: HttpClient, private cartService: CartService) {}

  ngOnInit(): void {
    this.sessionKey = this.route.snapshot.paramMap.get('session_key');

    if(this.sessionKey) {
      const url = `${BASE_URL}/api/packages/get_transaction/${this.sessionKey}`;
      this.http.get(url).subscribe({
        next: (res: any) => {
          this.isLoaded = true;
          if (res.status) {
            this.isSuccess = true;
            this.title = 'Thank You!';
            this.cartService.removeAll();
            if(res.file_path) {
              this.downloadFile(res.file_path);
            }
          } else {
            this.title = 'Sorry!'; 
            if(res.toRedirect) {
              location.href = '/';
            }
          }
          this.message = res.message;
        },
        error: (err) => {
          this.title = 'Sorry!';
          this.message = 'We apologize for the inconvenience caused, the issue is from our end and our team is working to resolve it at the earliest';
          this.isLoaded = true;
        }
      });
    } else {
      location.href = '/';
    }
  }

  downloadFile(filePath: string): void {
    const downloadUrl = `${BASE_URL}/uploads/download_zips_temp/${filePath}`;
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filePath.split('/').pop() || 'download';
    link.click();
  }
}
